import { render } from "./DeudaTotalComponent.vue?vue&type=template&id=a7f5d708&scoped=true"
import script from "./DeudaTotalComponent.vue?vue&type=script&lang=js"
export * from "./DeudaTotalComponent.vue?vue&type=script&lang=js"

import "./DeudaTotalComponent.vue?vue&type=style&index=0&id=a7f5d708&scoped=true&lang=css"

import exportComponent from "/Users/luismanuel/Documents/www/tuxtlacomovamos/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a7f5d708"]])

export default __exports__